import {MoneyPipe} from './money.pipe';

import {KeysPipe} from '../../../../common/components/pipes';
import {CapitalizePipe} from "./capitalize.pipe";

export const PIPES = [
    MoneyPipe,
    KeysPipe,
    CapitalizePipe
];


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/pipes/index.ts